export enum ContentType {
    Title = 0,
    Description = 1,
    Image = 2,
    Author = 4,
    FaqQuestion = 5,
}
